import BackofficeIndexBase from './BackofficeIndexBase.js';

export default class BackofficeStudyRequestsIndex extends BackofficeIndexBase {
  constructor() {
    super("#sr-datatable", {
      savedFiltersBannerId: 'study-request-saved-filters-banner'
    });

    this.bindEvents();
  }

  bindEvents() {
    this.bindSaveStepButton();
    this.bindStepDropdown('study_request_step', '#sr-datatable', '#sr-loader');
    this.bindFilterForm('#sr-loader');
    this.bindSaveFiltersButton('save-study-request-filters', 'clear-study-request-filters');
    this.bindClearFiltersButton('clear-study-request-filters');
  }

  onDataChanged() {
    // Custom logic for study requests
  }
}